import { render } from "./ProfileSection.vue?vue&type=template&id=7451ba36&scoped=true&ts=true"
import script from "./ProfileSection.vue?vue&type=script&lang=ts"
export * from "./ProfileSection.vue?vue&type=script&lang=ts"

import "./ProfileSection.vue?vue&type=style&index=0&id=7451ba36&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7451ba36"]])

export default __exports__